<div class="container">
  <div class="my-3">
    <h3 class="h3">New Trainer</h3>
    <p class="text-muted">Create a trainer from an existing or new user.</p>
  </div>
  <div class="pb-5">
    <app-create-trainer></app-create-trainer>
  </div>
</div>